/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import { string, node, func } from 'prop-types';
import classNames from 'classnames';
import Paragraph from './Paragraph';

import './Option.scss';

const Option = ({
  className,
  onClick,
  onMouseDown,
  children,
  value,
  dataSelectorId,
}) => (
  <div
    className={classNames({
      option: true,
      [className]: className && className.length > 0,
    })}
    data-value={value}
    onMouseDown={onMouseDown}
    onClick={onClick}
    data-selector={dataSelectorId}
  >
    <Paragraph>
      <strong>{children}</strong>
    </Paragraph>
  </div>
);

Option.propTypes = {
  className: string,
  onClick: func,
  onMouseDown: func,
  children: node,
  value: string,
  dataSelectorId: string,
};

Option.defaultProps = {
  className: null,
  value: undefined,
  onClick: undefined,
  onMouseDown: undefined,
  children: null,
  dataSelectorId: null,
};

export default Option;
